var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ready && _vm.date)?_c('ThemaHinzufuegen',{attrs:{"current-date":_vm.date}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }